import { useEffect } from 'react';
import './public-site.css';
import './support-page.css';

const Icon = ({ children, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

const PhoneIcon = () => (
  <Icon><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z" /></Icon>
);

const MailIcon = () => (
  <Icon><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 7 9-7" /></Icon>
);

const ArrowIcon = () => (
  <Icon size={16}><path d="M5 12h14M13 6l6 6-6 6" /></Icon>
);

function SupportPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Support | Tegrat Auto';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <div className="ps-root support-page">
      <div className="bg-deco" aria-hidden="true">
        <div className="dots" />
        <div className="blob b1" />
        <div className="blob b2" />
      </div>

      <nav className="ps-nav" aria-label="Support navigation">
        <a href="/" className="ps-nav-brand">
          <span className="ps-nav-mark">T</span>
          Tegrat Auto
        </a>
        <a href="/" className="support-home-link">Back to home</a>
      </nav>

      <main className="support-main">
        <section className="support-hero" aria-labelledby="support-title">
          <span className="eyebrow">
            <span className="e-dot"><span className="e-pulse" /></span>
            Customer support
          </span>
          <h1 id="support-title">We’re here to help.</h1>
          <p>
            Questions about your rental, payment, or vehicle? Call or email our team and
            we’ll point you in the right direction.
          </p>
        </section>

        <section className="support-options" aria-label="Ways to contact support">
          <article className="support-card">
            <div className="support-icon"><PhoneIcon /></div>
            <div>
              <p className="support-label">Call Nate</p>
              <h2><a href="tel:+13177099519">(317) 709-9519</a></h2>
              <p>Best for time-sensitive questions about your rental or vehicle.</p>
              <a className="support-action" href="tel:+13177099519">
                Call support <ArrowIcon />
              </a>
            </div>
          </article>

          <article className="support-card">
            <div className="support-icon support-icon-mail"><MailIcon /></div>
            <div>
              <p className="support-label">Email the team</p>
              <h2><a href="mailto:info@tegratauto.com">info@tegratauto.com</a></h2>
              <p>Include your name, current city, vehicle, and a short description of what you need.</p>
              <a className="support-action" href="mailto:info@tegratauto.com?subject=Tegrat%20Auto%20support%20request">
                Send an email <ArrowIcon />
              </a>
            </div>
          </article>
        </section>

        <aside className="support-note">
          <strong>On the road and in immediate danger?</strong>
          <span>Move to a safe location and call 911 first, then contact Tegrat Auto.</span>
        </aside>
      </main>

      <footer className="support-footer">
        <span>© 2026 Tegrat Auto · Des Dayton Digital LLC</span>
        <div>
          <a href="/privacy">Privacy</a>
          <a href="/sms-consent">SMS consent &amp; policy</a>
        </div>
      </footer>
    </div>
  );
}

export default SupportPage;
